import React, { FunctionComponent, useEffect, useState } from 'react'
import styles from './TaskRequest.module.sass'
import { PartialTask, Task } from '../../../../../../responses/tasks'
import { mergeObject, unboxRecord, unit } from '../../../../../../utils/utils'
import clsx from 'clsx'
import { TaskStatus } from '../../../../../../constants/enums'
import OkCancel from '../../../../../controls/OkCancel/OkCancel'
import { getId } from '../../../../../../utils/entity-utils'
import { apiRequests } from '../../../../../../http/config'
import { motion } from 'framer-motion'
import { fromQueryWithReset } from '../../../../../../utils/rx-operators'
import QuillEditor from '../../../../../etc/Editor/QuillEditor'
import { useUpload } from '../../../../../../utils/hooks'
import { isTempFileData } from '../../../../../../responses/files'
import Dropdown from '../../../../../data-components/dropdowns/Dropdown/Dropdown'
import { useObservableState } from 'observable-hooks'
import { TaskType } from '../../../../../../responses/refs/refs'
import DateDialog from '../../../../../data-components/date/DateDialog/DateDialog'
import {parseDate, toServerDate} from '../../../../../../utils/date-utils'
import DateInput from '../../../../../data-components/date/DateInput/DateInput'
import {useQueries} from '../../../../../../utils/hooks/useQueries'
import TaskChecklist from '../TaskChecklist/TaskChecklist'

interface Props {
    className?: string,
    edit?: boolean,
    task?: Task,
    onOk?: (task: PartialTask) => void,
    onCancel?: () => void,
    onUpdate?: (task: PartialTask) => void,
}

const TaskRequest: FunctionComponent<Props> = props => {
    const [task, setTask] = useState<PartialTask>({ status_id: TaskStatus.REQUESTED, priority_id: 1 })
    const [text, setText] = useState('')
    const {isMobile} = useQueries()
    const upload = useUpload(task.comment?.files)

    useEffect(() => {
        setTask(props.task || { status_id: TaskStatus.REQUESTED })
    }, [props.task])

    const [types, searchType] = useObservableState<TaskType[], {search: string, reset: boolean}>(fromQueryWithReset(
        query => apiRequests.dictionary.list({ params: { key: 'task-type' }, query })
    ), [])

    return <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className={clsx(props.className, styles.requestTask)}
    >
        <div className={styles.title}>
            {props.edit ? 'Запрос на открытие задачи' : 'Запрос на открытие задачи ожидает утверждения'}
        </div>
        <Dropdown
            className={styles.type}
            placeholder={'Тип задач'}
            selected={unit(task.type)}
            content={(selected, render) => selected.map(render).join()}
            data={types}
            toKey={getId}
            render={type => type.name}
            onChange={(search, reset) => searchType({search, reset})}
            onClick={type => props.edit ?
                setTask(mergeObject<PartialTask>({ type })) :
                props.onUpdate?.({ type })
            }
        />
        {
            isMobile ? <DateDialog
                className={styles.deadline}
                text={'Дедлайн'}
                disabledDays={{before: new Date()}}
                value={parseDate(task.deadline_at)}
                onChange={
                    deadline_at => props.edit ?
                        setTask(mergeObject<PartialTask>({ deadline_at: toServerDate(deadline_at) })) :
                        props.onUpdate?.({ deadline_at: toServerDate(deadline_at) })
                }
            /> : <DateInput
                className={styles.deadline}
                placeholder={'Дедлайн'}
                disabledDays={{before: new Date()}}
                value={parseDate(task.deadline_at)}
                onChange={
                    deadline_at => props.edit ?
                        setTask(mergeObject<PartialTask>({ deadline_at: toServerDate(deadline_at) })) :
                        props.onUpdate?.({ deadline_at: toServerDate(deadline_at) })
                }
            />
        }
        {
            task.type?.checklist && <TaskChecklist className={styles.checklist} content={task.type.checklist}/>
        }

        {
            props.edit && <QuillEditor
                className={styles.editor}
                placeholder={'Добавить комментарий'}
                value={text}
                onChange={setText}
                upload={upload}
            />
        }
        {
            props.edit && <OkCancel
                className={styles.actions}
                text={'Отправить'}
                onCancel={props.onCancel}
                onOk={() => props.onOk?.({
                    ...task,
                    comment: unboxRecord({
                        text,
                        files: upload.files.filter(isTempFileData).map(file => file.data),
                    })
                })}
            />
        }
    </motion.div>
}

export default TaskRequest